import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index.js';

Vue.use(Router);

// 导出路由配置
const router = new Router({
  mode: 'hash',
  linkActiveClass: 'activeRouter',
  routes: [
    {
      path: '/login', // 登录
      meta: {
        noAuth: true
      },
      name: 'Login',
      component: () => import('@views/user/login.vue')
    },
    {
      path: '/salesmanlogin', // 登录
      meta: {
        noAuth: true
      },
      name: 'salesmanLogin',
      component: () => import('@views/user/salesmanlogin.vue')
    },
    {
      path: '/hy', // 会议
      meta: {
        noAuth: true
      },
      name: 'hy',
      component: () => import('@views/index/hy/hy.vue')
    },
    {
      path: '/zxbm', // 会议报名
      meta: {
        noAuth: true
      },
      name: 'zxbm',
      component: () => import('@views/index/hy/zxbm.vue')
    },
    {
      path: '/yfjs', // 一份家书
      meta: {
        noAuth: true
      },
      name: 'yfjs',
      component: () => import('@views/index/hy/yfjs.vue')
    },
    {
      path: '/cxhy', // 查询会议
      meta: {
        noAuth: true
      },
      name: 'zxbm',
      component: () => import('@views/index/hy/cxhy.vue')
    },
    {
      path: '/reg/:id', // 注册
      meta: {
        noAuth: true,
        keepAlive: true
      },
      name: 'Reg',
      component: () => import('@views/user/reg.vue')
    },
    {
      path: '/registration/:id', // 二维码注册
      meta: {
        noAuth: true,
        keepAlive: true
      },
      name: 'Registration',
      component: () => import('@views/user/registration.vue')
    },
    {
      name: 'Protocol',
      path: '/protocol',
      meta: {
        noAuth: true
      },
      component: () => import('@views/user/protocol.vue')
    },
    {
      path: '/h',
      component: () => import('@views/base/header.vue'),
      children: [
        {
          path: 'forgot',
          component: () => import('@views/user/forgot.vue'),
          meta: {
            noAuth: true
          }
        },
        {
          path: 'index',
          component: () => import('@views/index/index.vue')
        },
        {
          path: 'salesmanindex',
          component: () => import('@views/index/salesmanindex.vue')
        },
        {
          path: 'Neworder',
          component: () => import('@views/index/water/Neworder.vue')
        },
        {
          path: 'order',
          component: () => import('@views/index/order/order.vue')
        },
        {
          path: 'orderold',
          component: () => import('@views/index/order/orderfapiaoold.vue')
        },
        {
          path: 'orderbuyfapiao',
          component: () => import('@views/index/water/orderbuyfapiao.vue')
        },
        {
          path: 'order-detail',
          component: () => import('@views/index/order/order-detail.vue')
        },
        {
          path: 'integral',
          component: () => import('@views/index/integral/integral.vue')
        },
        {
          path: 'recommend', // 注册
          meta: {
            noAuth: true
          },
          component: () => import('@views/user/recommend.vue')
        },
        {
          path: 'balance', // 注册
          component: () => import('@views/index/balance/balance.vue')
        },
        {
          path: 'balance-detail-order/:id',
          component: () => import('@views/index/balance/balance-detail.vue')
        },
        {
          path: 'balance-detail-income/:id',
          component: () => import('@views/index/balance/balance-detail.vue')
        },
        {
          path: 'balance-detail-expense/:id',
          component: () => import('@views/index/balance/balance-detail.vue')
        },
        { // 裂变详情
          path: 'balance-detail-fission/:id',
          component: () => import('@views/index/balance/balance-detail.vue')
        },
        { // 提现详情
          path: 'withdrawdetile/:id',
          component: () => import('@views/index/wallet/withdrawdetile.vue')
        },
        { // 提现详情
          path: 'withdrawdetile2/:id',
          component: () => import('@views/index/wallet/withdrawdetile2.vue')
        },
        { // 代理商提现详情
          path: 'dlwithdrawdetile/:id',
          component: () => import('@views/index/income/withdrawdetile.vue')
        }, {
          path: 'income',
          component: () => import('@views/index/income/income.vue')
        },
        { // 查看代理商的金额明细add-bank-card
          path: 'amount',
          component: () => import('@views/index/income/amountdetail')
        },
        { // 查看代理商的积分详情
          path: 'jifenldetile/:id',
          component: () => import('@views/index/income/jifenldetile')
        },
        { // 查看代理商的积分明细
          path: 'integraldetail',
          component: () => import('@views/index/income/integraldetail')
        },
        { // 我的代理商跳转
          path: 'branchwallet',
          component: () => import('@views/index/wallet/branchwallet')
        },
        { // 我的渠道商跳转
          path: 'qubranchwallet',
          component: () => import('@views/index/wallet/qubranchwallet')
        },
        {
          path: 'wallet',
          component: () => import('@views/index/wallet/wallet.vue')
        },
        {
          path: 'holder-wallet',
          component: () => import('@views/index/wallet/wallet.vue')
        },
        {
          path: 'my-shouru-holder/:isHolder',
          component: () => import('@views/index/wallet/total-wallet.vue')
        },
        {
          path: 'my-shouru/:isHolder',
          component: () => import('@views/index/wallet/total-wallet.vue')
        },
        {
          path: 'user-withdraw',
          component: () => import('@views/index/wallet/integral.vue')
        }, // 代理商提现
        {
          path: 'tixiannew',
          component: () => import('@views/index/order/tixiannew.vue')
        }, // 代理商提现
        {
          path: 'agent-withdraw',
          component: () => import('@views/index/company/withdrawal.vue')
        },
        {
          path: 'holder-withdraw/:holderId/:isHolder',
          component: () => import('@views/index/wallet/integral.vue')
        },
        {
          path: 'bank-card',
          component: () => import('@views/index/wallet/bank-card.vue')
        },
        {
          path: 'bank-cardnew',
          component: () => import('@views/index/wallet/bank-cardnew.vue')
        },
        {
          path: 'fapiaoz',
          component: () => import('@views/index/wallet/orderfapiao.vue')
        },
        {
          path: 'holder-bank-card',
          component: () => import('@views/index/wallet/bank-card.vue')
        },
        {
          path: 'edit-bank-card/:id',
          component: () => import('@views/index/wallet/edit-bank-card.vue')
        },
        {
          path: 'add-bank-card',
          component: () => import('@views/index/wallet/add-bank-card.vue')
        },
        {
          path: 'add-bank-cardnew',
          component: () => import('@views/index/wallet/add-bank-cardnew.vue')
        },
        {
          path: 'add-company-bank',
          component: () => import('@views/index/wallet/add-company-bank')
        },
        {
          path: 'add-bank-card/:holderId',
          component: () => import('@views/index/wallet/add-bank-card.vue')
        },
        {
          path: 'add-card-reg/:id',
          component: () => import('@views/index/wallet/add-card-reg.vue')
        },
        {
          path: 'realname-step1',
          component: () => import('@views/index/realname/step1.vue')
        },
        {
          path: 'realname-step2',
          component: () => import('@views/index/realname/step2.vue')
        },
        {
          path: 'realname-step3',
          component: () => import('@views/index/realname/step3.vue')
        },
        {
          path: 'withdraw-record',
          component: () => import('@views/index/wallet/withdraw-record.vue')
        },
        {
          path: 'withdraw-record/:holderId',
          component: () => import('@views/index/wallet/withdraw-record.vue')
        },
        {
          path: 'water-detail/:id',
          component: () => import('@views/index/water/detail.vue')
        },
        {
          path: 'water-order/:id',
          component: () => import('@views/index/water/order.vue'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'water-order-reg/:id',
          component: () => import('@views/index/water/order-reg.vue')
        },
        {
          path: 'add-address',
          component: () => import('@views/index/address/add-address.vue')
        },
        { // 意见反馈
          path: 'sendComplaint',
          component: () => import('@views/index/opinion/options.vue')
        },
        {
          path: 'address-list',
          component: () => import('@views/index/address/address-list.vue')
        },
        {
          path: 'edit-address/:id',
          component: () => import('@views/index/address/add-address.vue')
        },
        {
          path: 'recommend-qrcode',
          component: () => import('@views/index/recommend/recommend.vue')
        },
        {
          path: 'zhifubao',
          component: () => import('@views/index/water/zhifubao.vue')
        },
        {
          path: 'weixin',
          component: () => import('@views/index/water/wechatzhifu.vue')
        },
        {
          path: 'recommend-member',
          component: () => import('@views/index/recommend/member.vue')
        },
        {
          path: 'recommend-memberfour',
          component: () => import('@views/index/recommend/memberfour.vue')
        },
        {
          path: 'recommend-income',
          component: () => import('@views/index/recommend/income.vue')
        },
        {
          path: 'company',
          component: () => import('@views/index/company/company.vue')
        },
        {
          path: 'holder-detail/:id',
          component: () => import('@views/index/company/holder-detail.vue')
        },
        {
          path: 'water',
          component: () => import('@views/index/water/water.vue')
        },
        {
          path: 'user',
          component: () => import('@views/index/user.vue')
        },
        {
          path: 'salesmanuser',
          component: () => import('@views/index/salesmanuser.vue')
        },
        {
          path: 'salesmanpwd',
          component: () => import('@views/index/salesmanpwd.vue')
        },
        {
          path: 'salesmanstec/:id',
          component: () => import('@views/index/hy/salesmanstec.vue')
        },
        {
          path: 'salesmaner/:id',
          component: () => import('@views/index/hy/salesmaner.vue')
        },
        {
          path: 'salesmanindexlist',
          component: () => import('@views/index/salesmanindexlist.vue')
        },
        {
          path: 'hygl',
          component: () => import('@views/index/hy/hygl.vue')
        },
        {
          path: 'hyglindex/:meetingId',
          component: () => import('@views/index/hy/hyglindex.vue')
        }
      ]
    },
    /* {
      path: '*',
      redirect: '/h/index'
    },
    {
      path: '/',
      redirect: '/h/index'
    }, */
    {
      path: '*',
      redirect: function (to) {
        let id = store.state.user.userInfo.userType;
        console.log(900);
        console.log(id);
        if (id === '20000') {
          return '/h/salesmanindex';
        }
        if (id === '10000') {
          return '/h/index';
        } else {
          return '/h/index';
        }
      }
    },
    {
      path: '/',
      redirect: function (to) {
        let id = store.state.user.userInfo.userType;
        console.log(900);
        console.log(id);
        if (id === '20000') {
          return '/h/salesmanindex';
        }
        if (id === '10000') {
          return '/h/index';
        } else {
          return '/h/index';
        }
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let token = store.state.user.userInfo.token;
  console.log(to.meta.noAuth);
  console.log(token);
  console.log(7890);
  if (!token && !to.meta.noAuth) {
    next('/login');
    return;
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js